<template>
  <v-layout>
    <v-menu
            v-model="fromDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
                prepend-icon="event"
                readonly
                :value="fromDateDisp"
                v-on="on"
                @blur="sale"
                required
                :rules="[v => !!v || 'La fecha de nacimiento es necesaria']"
        >
          <template v-slot:label>
            Fecha de nacimiento<sup>*</sup>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
              locale="es-es"
              :max="maxDate"
              :min="minDate"
              v-model="fromDateVal"
              no-title
              first-day-of-week="1"
              @change="cambia"
              @input="fromDateMenu = false"
      ></v-date-picker>
    </v-menu>
  </v-layout>
</template>
<script>

  import moment  from "moment"
  export default {
    props:['current', 'minDate', 'max'],
    data() {
      return {
        fromDateMenu: false,
        fromDateVal: '',
        maxDate: moment().format("YYYY-MM-DD"),
        fnac: null,
        today: moment()
      }
    },
    created() {
      if (this.current) {
        this.today = moment(this.current)
        this.fromDateVal = this.today.format('YYYY-MM-DD')
      }
      if(this.max) {
        this.maxDate = moment(this.max).format("YYYY-MM-DD")
      }

    },
    computed: {
      fromDateDisp() {
        return (this.fromDateVal.split('-').reverse()).join('/')
      }
    },
    methods:{
      cambia() {

        this.$emit('change', moment(this.fromDateVal))
      },
      sale(){
        this.$emit('blur')
      }
    }
  };
</script>